import { Result } from '@empathy/search-types';
import { StorageService } from '@empathy/storage-service';
import { container } from '../../../container';
import { DEPENDENCIES, STORAGE } from '../../../container/dependencies.const';
import { EmpathyXConfig } from '../../../models';
import { ProductPageService } from '../../../services';
import { GETTERS_KEYS } from '../../store.const';
import { TRACKING_ACTIONS_KEYS, TRACKING_MUTATIONS_KEYS } from '../tracking.const';
import { TrackingAction, TrackingContext } from '../tracking.interfaces';

export class LoadResultIdAction implements TrackingAction {

  private context: TrackingContext;
  private productPageService: ProductPageService;
  private storageService: StorageService;

  actions = {
    [TRACKING_ACTIONS_KEYS.loadResultId]: (context: TrackingContext, resultId?: string) => {
      this.context = context;
      this.initDependencies();
      resultId = resultId ?? this.productPageService.getResultId();
      if (resultId) {
        context.commit(TRACKING_MUTATIONS_KEYS.saveProductPageResultId, resultId);
        this.checkTrackPendingClick(resultId);
      } else {
        context.commit(TRACKING_MUTATIONS_KEYS.saveProductPageResultId, '');
      }
    }
  };

  // TODO inject these dependencies when the action is an injectable
  private initDependencies() {
    this.productPageService = container.get<ProductPageService>(DEPENDENCIES.ProductPageService);
    this.storageService = container.getNamed<StorageService>(DEPENDENCIES.StorageService, STORAGE.Local);
  }

  private checkTrackPendingClick(resultId: string) {
    const { tracking }: EmpathyXConfig = this.context.rootGetters[GETTERS_KEYS.config.config];
    const rightClickResultId = this.storageService.getItem<string>(tracking.addToCart.storage.rightClickResultId);
    if (resultId === rightClickResultId) {
      this.storageService.removeItem(tracking.addToCart.storage.rightClickResultId);
      this.dispatchTrackClick(resultId);
    }
  }

  private dispatchTrackClick(resultId: string) {
    const result = this.storageService.getItem<Result>(resultId);
    if (result) {
      this.context.dispatch(TRACKING_ACTIONS_KEYS.trackClick, result);
    }
  }
}
